import { render, staticRenderFns } from "./AddItemToLibrary.vue?vue&type=template&id=3247918d&scoped=true&"
import script from "./AddItemToLibrary.vue?vue&type=script&lang=js&"
export * from "./AddItemToLibrary.vue?vue&type=script&lang=js&"
import style0 from "./AddItemToLibrary.vue?vue&type=style&index=0&id=3247918d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247918d",
  null
  
)

export default component.exports